import { render, staticRenderFns } from "./ClientCMSDataSync.vue?vue&type=template&id=2bf894d8&scoped=true&"
import script from "./ClientCMSDataSync.vue?vue&type=script&lang=js&"
export * from "./ClientCMSDataSync.vue?vue&type=script&lang=js&"
import style0 from "./ClientCMSDataSync.vue?vue&type=style&index=0&id=2bf894d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf894d8",
  null
  
)

export default component.exports